import accountModule from '../app.js';

import {userProfileManager,
    configManager,
    cookieUtil,
    AddressFormatterFactory,
    BankInfoService,
    AccountConfigManager} from '@nuskin/ns-common-account';

accountModule.service('addressFormatterFactory', function() {
    return AddressFormatterFactory;
});
accountModule.service('bankInfoService', BankInfoService);
accountModule.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
accountModule.service('configManager', function() {
    return configManager;
});

accountModule.service('businessService', ['$http',
    '$q',
    '$window',
    'addressFormatterFactory',
    'bankInfoService',
    'configManager',
    'AccountConfigManager',
    function($http, $q, $window, addressFormatterFactory, bankInfoService, configManager, AccountConfigManager) {
        var accountConfigManager = AccountConfigManager.getConfig(configManager);
        var countryCode = accountConfigManager.site['countryCode'];
        var languageCode = accountConfigManager['languageCode'];
        var meServer = accountConfigManager.site['meServer'];
        var sapServiceEndPoint = accountConfigManager.site['legacyServer'];
        var atlasServiceEndPoint = accountConfigManager.system['atlas_service_url'];
        var mulesoftStorefrontEndpoint = accountConfigManager.system['mulesoft.storefront_endpoint'];
        var addressFormatter = addressFormatterFactory.getAddressFormatter(countryCode);
        this.$http = $http;
        var deferredGigya = $q.defer();
        var deferredMulesoft = $q.defer();
        var deferredGigyaInfoVal = $q.defer();
        var languageListUrl = '/content/localization/countryandlanguagetranslation.service.{code}.json';
        var hybrisUser = userProfileManager.getUserProfileMasterInfo().userId;
        var userProfileInfo = userProfileManager.getUserProfileMasterInfo();
        var jwt = userProfileManager.getJWT();
        var sapServicePersonalProfileUrl = sapServiceEndPoint
            + '/customer/api/v1/person/{personId}?includeSponsor=true&includeInviter=true';
        var sapServiceBusinessProfileUrl = sapServiceEndPoint + '/customer/api/v1/account/';
        var invitationBaseUrl = sapServiceEndPoint + '/invitation/api/v2/invitation';
        // var sapServicePreferredNameUrl = '/cpm-service/api/1/attributes/';
        // var bankListUrl = '/eft-service/api/v2/banks/{market}.json';
        var validateSSNUrl = sapServiceEndPoint + '/account-util/api/v1/taxId/{ssn}/available?country={market}';

        var locale = languageCode + '_' + countryCode;

        var personId = hybrisUser? hybrisUser.toUpperCase() : '';

        var self = this;

        // var pageURL = $window.location.href;

        var ajaxConfig = {
            headers: {'content-type': 'application/json'}
        };

        /*        var deferredGigyaInfoService = function() {
                    function loginPostProcessor(eventObj) {
                        deferredGigyaInfoVal.resolve(eventObj.user);
                    }
                };*/

        this.getUserGigyaInfo = function() {
            return deferredGigyaInfoVal.promise;
        };

        this.scrollToTop = function(targetLocation) {
            var windowWidth = angular.element(window).width();
            var newLocation = null;
            if (windowWidth < 768) {
                newLocation = targetLocation && angular.element(targetLocation) ? targetLocation : '#rightPanel';
            } else {
                newLocation = '#rightPanel';
            }
            angular.element('html, body').animate({
                scrollTop: angular.element(newLocation).offset().top
            }, 400);
        };

        this.getEidDetails = function() {
            var eid = cookieUtil.getCookie('USER_PROFILE_JWT');
            if (null != eid && eid != undefined) {
                eid = JSON.parse(eid);
            }
            return eid;
        };

        this.loadDetails = function(userType) {
            // var eid = this.getEidDetails();
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var deferred = $q.defer();
            // New service url
            var url = sapServiceBusinessProfileUrl + accountId + '?includeSponsor=true&includeInviter=true';

            $http.get(url).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        this.profileHeaderInfo = function() {
            // var eid = this.getEidDetails();
            // var accountId = userProfileManager.getUserProfileMasterInfo().accountId;

            var config = {
                headers: {
                    'content-type': 'application/json',
                    'showgloballoader': true
                }
            };
            var deferred = $q.defer();

            // todo Use the new person endpoint.
            var url = sapServicePersonalProfileUrl.replace('{personId}', personId);
            $http.get(url, config).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        this.removeAssociate = function(details) {
            var url = mulesoftStorefrontEndpoint + 'account/delete/' + details.invitationUuId;


            var deferred = $q.defer();
            $http.post(url).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };
        this.validateBankingInfo = function(bankingInfo) {
            var url = '/etc/clientlibs/mecommerce/signup/account-settings-business/js/json/validateBankAccSucc.json';

            if (!(-1 === (($window.location.pathname).search('mock')))) {
                url = '/etc/clientlibs/mecommerce/signup/account-settings-business/js/json/validateBankAccFail.json';
            }
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        this.isDistributorEligible = function(data) {
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var jwt_token = userProfileManager.getJWT();
            var config = {
                headers: {
                    'content-type': 'application/json'
                }
            };

            var url = atlasServiceEndPoint + 'eligible/' + accountId + '.json?eid=' + jwt_token;
            var deferred = $q.defer();
            $http.get(url, config).then(function(status) {
                deferred.resolve(status);
            });
            return deferred.promise;
        };

        this.saveTaxID = function(bussName, taxID) {
            /* As per new Requirement SSN/TaxID will be formatted from AEM End*/
            taxID = taxID.replace(/(\d{2})(\d+)/, '$1-$2');
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            var requestData = {
                'businessName': bussName,
                'taxId': taxID
            };

            var deferred = $q.defer();
            $http.post(mulesoftHybrisEndpoint + 'v2/nuskin_' + market + '/users/' + hybrisUser
                + '/profile/business' + '/accountDetails', requestData, config).then(function(response) {
                deferred.resolve(response.status);
            }, function failureCallback(response) {
                /* MEC- 9629 Failure case was not handled*/
                deferred.reject(response);
            });
            return deferred.promise;
        };

        this.saveBankingInfo = function(bankingInfo) {
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            var requestData = {
                'accountName': bankingInfo.accountName,
                'accountType': bankingInfo.accountType,
                'accountNumber': bankingInfo.accountNumber,
                'routingNumber': bankingInfo.routingNumber,
                'directDepositPolicy': bankingInfo.directDeposit
            };

            if (bankingInfo.id) {
                var url = mulesoftHybrisEndpoint + 'v2/nuskin_' + market + '/users/'
                    + hybrisUser + '/bankingdetails/' + bankingInfo.id + '?type=account';
                var deferred = $q.defer();
                $http.patch(url, requestData, config).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            } else {
                var url = mulesoftHybrisEndpoint + 'v2/nuskin_' + market + '/users/'
                    + hybrisUser + '/business/bankingdetails';
                var deferred = $q.defer();
                $http.post(url, requestData, config).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            }
        };

        this.getAvailableBanksForMarket = function(country) {
            var config = {
                headers: {
                    'content-type': 'application/json'
                }
            };
            var url = atlasServiceEndPoint + 'banks/' + countryCode +'.json';
            var deferred = $q.defer();
            $http.get(url, config).then(function(response) {
                if (response.status === 200) {
                    deferred.resolve(response.data);
                }
            });
            return deferred.promise;
        };

        this.setAddresstDetails = function(address) {
            // var eid = this.getEidDetails();
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var config = {
                headers: {

                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            var formattedAddress = addressFormatter.formatToService(address);
            var dataAddress = {
                'addresses': {
                    'local': formattedAddress
                }
            };
            dataAddress.changeBy = personId;
            var url = sapServiceBusinessProfileUrl + accountId;
            return $http.put(url, dataAddress, config);
        };

        this.setContactDetails = function(contact) {
            // var eid = this.getEidDetails();
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            var dataContact = {
                'email': contact.email,
                'phoneNumbers': {
                    'mobile': {
                        'country': contact.phoneCode,
                        'value': contact.phone
                    }
                }
            };

            dataContact.changeBy = personId;
            var deferredForContactSet = $q.defer();
            var url = sapServiceBusinessProfileUrl + accountId;
            $http.put(url, dataContact, config).then(function(response) {
                deferredForContactSet.resolve(response.status);
            });
            return deferredForContactSet.promise;
        };

        this.setAccountDetails = function(data) {
            // var eid = this.getEidDetails();
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };
            data.changeBy = personId;
            var deferredForContactSet = $q.defer();
            var url = sapServiceBusinessProfileUrl + accountId;
            $http.put(url, data, config).then(function(response) {
                deferredForContactSet.resolve(response.status);
            });
            return deferredForContactSet.promise;
        };

        this.setHeaderInfoGigya = function(data) {
            var params = {
                profile: {
                    firstName: data.firstname,
                    lastName: data.lastname
                },
                callback: function(response) {
                    deferredGigya.resolve(response.status);
                }
            };
            gigya.accounts.setAccountInfo(params);

            return deferredGigya.promise;
        };

        this.setHeaderInfoHybris = function(data) {
            // var eid = this.getEidDetails();
            // var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var deferred = $q.defer();

            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };
            // TODO include profile picture in request
            var user = {
                'names': {
                    'local': {
                        'given': data.firstname,
                        'family': data.lastname
                    }
                },
                'preferredName': data.preferredname,
                'profileImageUrl': data.profilePictureUrl,
                'profileThumbnailUrl': data.profileImage
            };
            user.changeBy = personId;
            var url = sapServicePersonalProfileUrl.replace('{personId}', personId);

            $http.put(url, user, config).then(function(response) {
                deferred.resolve(response.status);
            });
            return deferred.promise;
        };

        this.uploadPhoto = function(files) {
            var deferred = $q.defer();
            var promise = null;
            var promise = getBase64(files[0]);

            promise.then(function(file) {
                deferred.resolve(file);
            });

            return deferred.promise;
        };

        this.uploadPhotoToGigya = function(file) {
            var deferred = $q.defer();
            var promise = null;
            var fileData = file.substr(file.indexOf(',') + 1);
            var params = {
                photoBytes: fileData,
                publish: 'true',
                callback: function(response) {
                    deferred.resolve(response);
                }
            };
            gigya.accounts.setProfilePhoto(params);
            return deferred.promise;
        };

        this.removeProfilePhoto = function() {
            var deferredGigya = $q.defer();

            var params = {
                profile: {
                    photoURL: '',
                    thumbnailURL: ''
                },
                callback: function(response) {
                    deferredGigya.resolve(response.status);
                }
            };
            gigya.accounts.setAccountInfo(params);

            return deferredGigya.promise;
        };

        /**
         * Gets base64 version of file.
         * @param {File} file
         * @return {Promise} promise
         */
        function getBase64(file) {
            var deferred = $q.defer();
            var reader = new FileReader();
            var isFile = typeof file.name == 'string';
            if (isFile) {
                reader.readAsDataURL(file);

                reader.onload = function(e) {
                    deferred.resolve(reader.result);
                };
                reader.onerror = function(error) {

                };
            } else {
                deferred.resolve(file);
            }
            return deferred.promise;
        }

        this.getAccountManager = function() {
            var url = meServer + '/mecommerce/getAccountManagerServlet?accountID=' + userProfileInfo.accountId
                + '&jwtToken=' + jwt + '&locale=' + locale;
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        this.getLanguageListFromLocale = function(country) {
            var deffered = $q.defer();
            var aUrl = languageListUrl;
            aUrl = aUrl.replace('{code}', languageCode);

            $http.get(aUrl).then(function(response) {
                var result = Object.values(response.data[country]);
                var languages = Object.entries(result[1]).map(([code, name]) => ({code, name}));
                deffered.resolve(languages);
            });
            return deffered.promise;
        };

        this.setHeaderInfoMuleSoft = function(data) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'showgloballoader': true
                }
            };

            var user = 'firstName=' + data.firstname + '&lastName=' + data.lastname + '&nickName=' + data.preferredname;

            var url = mulesoftHybrisEndpoint + 'v2/nuskin_' + market + '/users/balias@balias.com/profileHeader';

            $http.put(url, user, config).then(function(response) {
                deferredMulesoft.resolve(response.status);
            });
            return deferredMulesoft.promise;
        };


        this.loadStateDetails = function() {
            var deferred = $q.defer();
            var listUrl = '';
            if (market == 'us') {
                listUrl = '/etc/clientlibs/mecommerce/signup/account-settings-business/js/json/statelist.json';
            } else if (market == 'ca') {
                listUrl = '/etc/clientlibs/mecommerce/signup/account-settings-personal/json/provincelist.json';
            }
            $http.get(listUrl).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        this.acceptButtonClicked = function(versionNUmber) {
            var config = {
                headers: {

                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            var acceptData = {};
            acceptData.versionNumber = versionNUmber;

            var url = sapServiceBusinessProfileUrl + accountId + '/convertToBusiness';

            var deferred = $q.defer();
            $http.post(url, acceptData, config).then(function(response) {
                deferred.resolve(response.status);
            });
            return deferred.promise;
        };

        this.saveCommunicationPreference = function(preferences, contactPreferenceText) {
            // var eid = this.getEidDetails();
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;

            var data = {
                'preferredLanguage': preferences.language.code.toUpperCase(),
                'preferences': {
                    'acceptMarketingEmail': preferences.emailIsOpted,
                    'acceptMarketingSMS': preferences.textIsOpted,
                    'contactPreference': preferences.emailIsOpted ? contactPreferenceText.toUpperCase() : undefined
                }
            };

            var config = {
                headers: {
                    'content-type': 'application/json',
                    'showgloballoader': true
                }
            };
            data.changeBy = personId;
            var url = sapServiceBusinessProfileUrl + accountId;
            var deferred = $q.defer();
            $http.put(url, data, config).then(function(response) {
                deferred.resolve(response.status);
            });
            return deferred.promise;
        };


        this.invitationList = function() {
            var aUrl = invitationBaseUrl + '?filter=hostID={personId}';

            aUrl = aUrl.replace('{personId}', personId);

            return $http.get(aUrl);
        };

        this.invitationCreate = function(memberInfo, invitationType) {
            var aUrl = invitationBaseUrl + '?locale=' + locale;

            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            // var eid = self.getEidDetails();
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var hostFirstName = '';
            var hostLastName = '';
            var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
            if (userProfileDetailInfo && userProfileDetailInfo.profileHeader) {
                hostFirstName = userProfileDetailInfo.profileHeader.firstName;
                hostLastName = userProfileDetailInfo.profileHeader.lastName;
            }

            var user = {
                'type': invitationType,
                'hostPersonID': personId,
                'guestPersonID': '',
                'guestEmailAddress': memberInfo.email,
                'guestFirstName': memberInfo.firstname,
                'guestLastName': memberInfo.lastname,
                'messageData': {
                    'PARAM1': accountId,
                    'PARAM2': hostFirstName,
                    'PARAM3': hostLastName,
                    'FIRSTNAME': memberInfo.firstname,
                    'ACCOUNTHOLDER': hostFirstName + ' ' + hostLastName
                }
            };

            return $http.post(aUrl, user, config);
        };

        self.invitationRead = function(invitationUuId) {
            var aUrl = invitationBaseUrl + '/' + invitationUuId;

            return $http.get(aUrl);
        };

        self.invitationUpdateAndResend = function(invitation) {
            var aUrl = invitationBaseUrl + '/' + invitation.ID + '?resend=true&locale=' + locale;

            return $http.put(aUrl, invitation);
        };

        self.invitationResend = function(invitationUuId) {
            var deferred = $q.defer();

            self.invitationRead(invitationUuId).then(function(response) {
                // var eid = self.getEidDetails();
                var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
                var hostFirstName = '';
                var hostLastName = '';
                var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
                if (userProfileDetailInfo && userProfileDetailInfo.profileHeader) {
                    hostFirstName = userProfileDetailInfo.profileHeader.firstName;
                    hostLastName = userProfileDetailInfo.profileHeader.lastName;
                }
                if (response && response.data && response.data.invitation) {
                    var invitation = response.data.invitation;
                    var invitationToChange = {
                        'ID': invitation.UUID,
                        'hostPersonID': invitation.hostPersonID,
                        'guestPersonID': invitation.guestPersonID,
                        'guestEmailAddress': invitation.guestEmailAddress,
                        'guestFirstName': invitation.guestFirstName,
                        'guestLastName': invitation.guestLastName,
                        'type': invitation.type,
                        'messageData': {
                            'PARAM1': accountId,
                            'PARAM2': hostFirstName,
                            'PARAM3': hostLastName,
                            'FIRSTNAME': invitation.guestFirstName,
                            'ACCOUNTHOLDER': hostFirstName + ' ' + hostLastName
                        }
                    };

                    self.invitationUpdateAndResend(invitationToChange).then(function(response) {
                        if (response.data && response.data.invitation) {
                            deferred.resolve(response.data.invitation);
                        } else {
                            deferred.reject('Cannot update/resend invitation');
                        }
                    }, function(reason) {
                        deferred.reject(reason);
                    });
                } else {
                    deferred.reject('No invitation for given invitationUuId:' + invitationUuId);
                }
            }, function(reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        };

        this.getHeaderDetails = function() {
            // var eid = this.getEidDetails();
            var config = {
                headers: {
                    'content-type': 'application/json',
                }
            };
            var deferred = $q.defer();
            var url = sapServicePersonalProfileUrl.replace('{personId}', personId);
            $http.get(url, config).then(function(response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        };

        this.setPaymentDetails = function(data) {
            return bankInfoService.writeBankInfoToAccount(data);
        };

        this.getDistributorInfoPayment = function() {
            return bankInfoService.getBankInfoForAccount();
        };

        this.getAccountInfo = function() {
            var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
            var config = {
                headers: {
                    'content-type': 'application/json'
                }
            };

            var url = sapServiceBusinessProfileUrl + accountId;
            var deferred = $q.defer();
            $http.get(url, config).then(function(status) {
                deferred.resolve(status);
            });
            return deferred.promise;
        };

        /* Adding this function to validate tax-id unique ness*/
        this.validateSSN = function(ssn) {
            var aUrl = validateSSNUrl.replace('{ssn}', ssn).replace('{market}', countryCode);
            return $http.get(aUrl, ajaxConfig);
        };

        this.returnMask = function(country) {
            var mask ='';
            switch (country) {
            case 'GB': // UK
                mask = '** **** **** **** **** **';
                break;
            case 'ES': // spain
                mask = '** **** **** **** **** **** ';
                break;
            case 'PF': // french polynesia
                mask = '** ***** ***** *********** **';
                break;
            case 'FR': // France
                mask = '** **** **** **** **** **** ***';
                break;
            }

            return mask;
        };

        this.convertToBusiness = function(payload) {
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'showgloballoader': true
                }
            };

            var url = sapServiceBusinessProfileUrl + userProfileInfo.accountId + '/convertToBusiness';
            return $http.put(url, payload, config);
        };
    }]);



//////////////////
// WEBPACK FOOTER
// ./services/business-service.js
// module id = 376
// module chunks = 0